const setViewMode = (mode: string) => ({
    type: 'SET_VIEW_MODE',
    mode,
  })
  
  export default setViewMode
  